export const SAVE_PASSWORD = 'RESTORE_PASSWORD/SAVE_PASSWORD';
export const SAVE_PASSWORD_SUCCESS = 'RESTORE_PASSWORD/SAVE_PASSWORD_SUCCESS';
export const SAVE_PASSWORD_ERROR = 'RESTORE_PASSWORD/SAVE_PASSWORD_ERROR';
export const SET_PASSWORD = 'RESTORE_PASSWORD/SET_PASSWORD';
export const SET_CONFIRM_PASSWORD = 'RESTORE_PASSWORD/SET_CONFIRM_PASSWORD';
export const SET_TOKEN = 'RESTORE_PASSWORD/SET_TOKEN';
export const SET_LOGIN_TYPE = 'RESTORE_PASSWORD/SET_LOGIN_TYPE';
export const SET_HISTORY = 'RESTORE_PASSWORD/SET_HISTORY';
export const RESET_STATE = 'RESTORE_PASSWORD/RESET_STATE';